import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DataFormSubmitPage = () => {
  const searchParams = useLocation().search;
  useEffect(() => {
    const payUrl = new URLSearchParams(searchParams).get('payUrl');
    const encryptData = new URLSearchParams(searchParams).get('data');

    if (encryptData && payUrl) {
      const data = JSON.parse(decodeURIComponent(encryptData));

      createFormAndSubmit(data, payUrl);
    }
  }, [searchParams]);

  const createFormAndSubmit = (formData, returnUrl) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);

    form.submit();
  };

  return null;
};

export default DataFormSubmitPage;
